export default __webpack_public_path__ + "media/images/dog-running-ab27850b33e8bacd0c306c0567409c63.png";